module.exports = __webpack_public_path__ + "assets/img/build_banner.f2a462bd.png";